import { render, staticRenderFns } from "./ReportRxqx.vue?vue&type=template&id=6862e75d"
import script from "./ReportRxqx.vue?vue&type=script&lang=js"
export * from "./ReportRxqx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports